import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { assets } from '../assets/assets';
import AboutCollection from '../components/AboutCollection';
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";


const About = () => {
  // Create a ref for the "note" section
  const noteRef = useRef(null);
  const ourValuesRef = useRef(null);
  const ourTeamRef = useRef(null);
  const legalFinancialsRef = useRef(null);

  // Function to scroll to the note section
  const scrollToNote = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      {/* ======================= nav Start ============================ */}
      <div className="nav_lists">
        <ul>
          <li><Link >About Us</Link></li>
          <li><Link onClick={() => scrollToNote(noteRef)}>Note from CEO</Link></li>
          <li><Link onClick={() => scrollToNote(ourValuesRef)} >Our Values</Link></li>
          <li><Link onClick={() => scrollToNote(ourTeamRef)}>Our Team</Link></li>
          <li><Link onClick={() => scrollToNote(legalFinancialsRef)}>Legal & Financials</Link></li>
        </ul>
      </div>
      {/* ======================= nav end  ============================ */}

      {/* ======================= banner start  ============================ */}
      <div
        className="about_banner py-5 mb-5 position-relative overflow-hidden"
        style={{ backgroundImage: `url(${assets.about_banner_img})` }}
        id="about"
      >
        <div className="container">
          <div className="content position-relative z-1">
            <div className="text-center text-sm-start">
              <h1>About Ihskas</h1>
            </div>
            <p>
              Ihskas mission is to "make giving bigger and better". We are the most trusted giving platform in
              India. Through our technology solutions and services, we enable individuals and organizations to
              raise funds for, and donate to any cause they care about, with trust and convenience. Our community
              of 2.7M+ individual donors and 300+ organizations supports 3,000+ verified nonprofits, serving 15M+
              people across the country.
            </p>
          </div>
        </div>
      </div>
      {/* ======================= banner end  ============================ */}

      <AboutCollection />

      {/* ======================= about ceo start  ============================ */}
      <div className="ceo_section py-5"  ref={noteRef}>
        <div className="container">
          <div className="row gy-4 gy-lg-0 text-center text-sm-start">
            <div className="col-lg-3">
              <div className="ceo text-center position-relative overflow-hidden">
                <img src={assets.ceo_img} className="w-100 rounded-top-3" alt="Atul Satija," />
                <div className="ceo_info">
                  <p className="card-text">
                  Lorem Ipsum
                  </p>
                  <span className="card-text">Founder 2.0 & CEO, Give</span>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="about-text">
                <h2 className="mb-5">Note from Founder 2.0 and CEO</h2>
                <p>
                Ihskas  and its partners were born to bridge the gap between the people who want to make a
              difference through giving back and those who are doing phenomenal work but need more
              support. Our focus has been to build trust for the social sector by strong due diligence of
              all our nonprofit partners, and transparency on how donations impacted lives on the ground.
            </p>
            <p>
              We are proud to have played a small role in enabling giving across all segments of our
              society - everyday givers, (U)HNI givers, corporates, and foundations. Over the last 20
              years, ihskas has enabled giving through marathons, galas, giving pledges, payroll giving,
              crowdfunding, philanthropy consulting, CSR grant management, collective giving, disaster
              response, etc.
            </p>
                <p>
                  We will continue to stay tuned to the needs on the ground, innovate for scale, and find ways
                  of inspiring every person who can to give back. India is a country that is rich in so many
                  resources. There is no reason for 300 million citizens to continue to live below the poverty
                  line. Join us in working towards our dream of seeing a poverty-free India within our lifetimes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======================= about ceo end  ============================ */}

      {/* <!-- ======================= value start  ============================ --> */}
    <div className="about_value_sec mt-5 mb-5" ref={ourValuesRef}>
        <div className="container">
            <div className="heading-txt text-center mb-5">
                <h2>Our Values</h2>
                <p>Our vision is to alleviate poverty by enabling the world to give</p>
            </div>
            <div className="row gy-3 gy-xl-0 text-center text-md-start">
                <div className="col-md-6 col-xl-3 mb-3">
                    <div className="card border-0 h-100 box-item">
                        <div className="box-icon mb-4">
                            <img src={assets.value_icon1} className="img-fluid" alt=""/>
                        </div>
                        <h3>Integrity in everything we do</h3>
                        <p>We strive never to take the easy path, but always the honest one. We practice integrity in
                            all
                            our actions and try to do the right thing by every stakeholder.
                        </p>
                    </div>
                </div>

                <div className="col-md-6 col-xl-3 mb-3">
                    <div className="card border-0 h-100 box-item">
                        <div className="box-icon mb-4">
                            <img src={assets.value_icon2} className="img-fluid" alt=""/>
                        </div>
                        <h3>Serve with passion</h3>
                        <p>We are fiercely committed to our purpose of poverty alleviation, and work with a burning
                            desire to make a difference.
                        </p>
                    </div>
                </div>

                <div className="col-md-6 col-xl-3 mb-3">
                    <div className="card border-0 h-100 box-item">
                        <div className="box-icon mb-4">
                            <img src={assets.value_icon3} className="img-fluid" alt=""/>
                        </div>
                        <h3>Focused on scale</h3>
                        <p>We stay laser-focused on large-scale impact. If we can’t scale it, we park it.</p>
                    </div>
                </div>

                <div className="col-md-6 col-xl-3 mb-3">
                    <div className="card border-0 h-100 box-item">
                        <div className="box-icon mb-4">
                            <img src={assets.value_icon4} className="img-fluid" alt=""/>
                        </div>
                        <h3>Empathy for all</h3>
                        <p>We are committed to working together with unconditional respect, freedom, trust and support
                            for each other.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- ======================= value end  ============================ --> */}

    {/* <!-- ======================= team start  ============================ --> */}
    <div className="team_section py-5 mb-5" ref={ourTeamRef}>
        <div className="container">
            <div className="heading-txt text-center pb-5">
                <h2>Our Team</h2>
                <p>SaathiRe Social Impact Solutions Pvt Ltd</p>
            </div>
            <div className="row gy-4 gy-xl-0">
                <div className="col-sm-6 col-lg-4 col-xl-3">
                    <div className="profile-card rounded-4 position-relative overflow-hidden">
                        <div className="profile-img">
                            <img src={assets.team_img1} className="w-100" alt="Profile 2"/>
                        </div>
                        <div className="social-icons position-absolute">
                            <a href="#"><FaFacebookF/></a>
                            <a href="#"><FaInstagram/></a>
                        </div>
                        <div className="plus-icon">+</div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4 col-xl-3">
                    <div className="profile-card rounded-4 position-relative overflow-hidden">
                        <div className="profile-img">
                            <img src={assets.team_img2} className="w-100" alt="Profile 2"/>
                        </div>
                        <div className="social-icons position-absolute">
                        <a href="#"><FaFacebookF/></a>
                        <a href="#"><FaInstagram/></a>
                        </div>
                        <div className="plus-icon">+</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- ======================= team end  ============================ --> */}

    {/* <!-- ======================= financial info start  ============================ --> */}
    <div className="financial_section mb-5" ref={legalFinancialsRef}>
        <div className="container overflow-hidden">
            <div className="heading-txt text-center mb-0 mb-xl-5 pb-5">
                <h2>Legal & Financial Information</h2>
            </div>
            <div className="financial_wrapper">
                <div className="row g-0">
                    <div className="col-xl-7 order-xl-2">
                        <div className="financial_images text-center text-xl-start h-100 position-relative">
                            <div className="financial_box">
                                <div className="img_2 position-absolute z-1">
                                    <img src={assets.legal_img2} className="img-fluid" alt=""/>
                                </div>
                                <div className="img_1 position-relative overflow-hidden">
                                    <img src={assets.legal_img1} className="img-fluid" alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 order-xl-1">
                        <div className="financial_content rounded-start-3 h-100">
                            <h4>Ihskas <br/> Founation</h4>
                            <p><strong>EIN:</strong> 87-4554363</p>
                            <p><strong>Address:</strong>
                                651 N, Broad St.,
                                Suite 206, Middletown,Newcastle, Delaware - 19709
                            </p>
                            <ul className="mt-4">
                                <li>Conflict of Interest Policy</li>
                                <li>Whistleblower Policy</li>
                                <li>Document Retention Policy</li>
                            </ul>
                            <div className="mt-4">
                                <h5>Registered Address:</h5>
                                <p>Dindaspur, Jansa Varanasi, UP-221405</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    {/* <!-- ======================= financial info end  ============================ --> */}
    </div>
  );
};

export default About;
